import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { globals } from "../globals";
import { Categoria } from "../models/categoria";
import { Etapa } from '../models/etapa';
import { Observable } from "rxjs";
import { EtapaFunilGetOneResponse } from "../orcamento/services/funil-etapa-orcamento-config.services";

@Injectable({
  providedIn: 'root'
})
export class CategoriaService {

  constructor(
    private http: HttpClient
  ) { }

  buscar(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Categoria/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  buscarCategoriasPorFamilia(idFamilia: number): Observable<Categoria[]> {
    return this.http.get<Categoria[]>(globals.apiUrl + '/api/Categoria/BuscarCategoriasPorFamilia',
      { params: new HttpParams().set('idFamilia', idFamilia.toString()) });
  }

  listar(ativo = 1) {
    return this.http.get<Categoria[]>(globals.apiUrl + '/api/Categoria/Listar',
      { params: new HttpParams().set('ativo', ativo.toString()) });
  }

  consultarComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, ativo, origens) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('ativo', ativo);

    if (origens != null) {
      parametros = parametros.set('origens', origens.join(','));
    }

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Categoria/ListaPag',
      {
        params: parametros
      });
  }

  salvar(categoria: Categoria) {
    return this.http.post(globals.apiUrl + '/api/Categoria/Salvar', categoria);
  }

  atualizaOrdem(idCategoria, ordem) {
    return this.http.patch(globals.apiUrl + '/api/Categoria/SalvarOrdem', {},
      { params: new HttpParams().set('idCategoria', idCategoria).set('ordem', ordem) });
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Categoria/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  softDelete(id) {
    return this.http.delete(globals.apiUrl + '/api/Categoria/SoftDelete',
      { params: new HttpParams().set('id', id) });
  }
}
